//根据子级获取多级菜单
const findParentList = (arr, component) => {
  for(let i = 0; i < arr.length; i++) {
    if(arr[i].component === component) return [arr[i] || {}]

    if(arr[i].children && arr[i].children.length) {
      const sub = findParentList(arr[i].children, component)
      if(sub) return [arr[i]].concat(sub)
    }
  }

  return
}

//当前登录用户菜单数据
export default {
  state: {
    menus: []
  },

  getters: {
    //获取面包屑
    crumb: state => component => {
      return findParentList(state.menus, component) || []
    },

    //判断是否有相应的权限
    auth: state => perms => {
      return JSON.stringify(state.menus).indexOf(perms) === -1 ? false : true
    }
  },

  mutations: {
    //保存菜单
    saveMenus(state, value) {
      state.menus = value
    }
  }
}
